import { combineReducers } from "redux";

import LayoutReducer from "./layouts/reducer";
import reformCalendarReducer from "./reform-calendar";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    ReformCalendar: reformCalendarReducer,
});

export default rootReducer;